import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import {
  LanguageFormContainer,
} from '../../containers/LanguageFormContainer/LanguageFormContainer';
import { NarrowModal } from '../NarrowModal/NarrowModal';
import styles from './StoreSwitcherModal.module.css';

export type Props = {
  isOpen: boolean;
  onModalClose: () => void;
};

const messages = defineMessages({
  title: {
    id: 'src.components.StoreSwitcherModal.title',
    defaultMessage: 'Select your country and language',
  },
});

export const StoreSwitcherModal = React.memo((props: Props) => {
  const {
    isOpen,
    onModalClose,
  } = props;

  return (
    <NarrowModal
      isOpen={isOpen}
      shouldCloseOnEsc
      onClose={onModalClose}
      modalHeaderClassName={styles.modalHeaderClassName}
      title={<FormattedMessage {...messages.title} />}
      titleVariant='h3'
      titleClassName={styles.languageFormTitle}
      modalContentWrapperClassName={styles.modalContentWrapperClassName}
      modalContentClassName={styles.modalContentClassName}
      closeBtnClassName={styles.closeBtnClassName}
    >
      <LanguageFormContainer onClose={onModalClose} />
    </NarrowModal>
  );
});

StoreSwitcherModal.displayName = 'StoreSwitcherModal';
